<div class="provider-accordion" [attr.aria-hidden]="!isExpanded" *ngIf="isExpanded" [@accordion]>
  <ng-content></ng-content>
</div>
